import DOMPurify from 'dompurify';

const RICH_TEXT_PURIFY_CONFIG = {
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'src', 'alt', 'style'],
  ALLOWED_TAGS: ['a', 'span', 'strong', 'em', 'u', 'br', 'p', 'img'],
};

export const sanitizeRichText = (html: string): string =>
  DOMPurify.sanitize(html, RICH_TEXT_PURIFY_CONFIG);

const decodeBase64Utf8 = (base64: string): string => {
  try {
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
  } catch {
    return '';
  }
};

const decodeHtmlEntities = (html: string): string => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

export const decodeAndSanitizeBase64Html = (base64: string): string => {
  const raw = decodeBase64Utf8(base64);
  if (!raw?.trim()) return '';
  const html = decodeHtmlEntities(raw);
  return sanitizeRichText(html);
};
